import { type ReassistMonthlyBilling } from "../types";

/** 月の請求の、手数料・経費・消費税・税込の合計。依頼と黒塗り購入を合わせた額。 */
export interface BillingTotals {
  /** 手数料の合計（税抜）。依頼の取得手数料と、黒塗り購入のクレジット。 */
  handlingFee: number;
  /** 経費の合計（非課税）。黒塗り購入には経費が無い。 */
  expense: number;
  /** 消費税の合計。 */
  tax: number;
  /** 請求合計（税込）。 */
  total: number;
}

/**
 * 依頼の手数料・経費の合計。金額が未定の暫定（内訳が無い依頼）は、税込の合計と同じく含めない。
 * @param billing - 月の請求
 * @returns 依頼分の手数料と経費の合計
 */
export const requestFeeTotals = (
  billing: ReassistMonthlyBilling
): { handlingFee: number; expense: number } =>
  billing.items.reduce(
    (sum, item) => ({
      handlingFee: sum.handlingFee + (item.handlingFee ?? 0),
      expense: sum.expense + (item.expense ?? 0),
    }),
    { handlingFee: 0, expense: 0 }
  );

/**
 * 月の請求の合計（依頼＋黒塗り購入）を、手数料・経費・消費税・税込に分けて返す。
 * @param billing - 月の請求
 * @returns 合計
 */
export const billingTotals = (
  billing: ReassistMonthlyBilling
): BillingTotals => {
  const request = requestFeeTotals(billing);
  return {
    handlingFee: request.handlingFee + billing.purchaseCreditTotal,
    expense: request.expense,
    tax: billing.taxTotal + billing.purchaseTax,
    total: billing.grandTotal,
  };
};
